// src/api/notificationApi.js
import api from './api';

export const getNotifications = () => {
  return api.get('/notifications');
};

export const markNotificationAsRead = (id) => {
  return api.put(`/notifications/${id}/read`);
};

export const deleteNotification = (id) => {
  return api.delete(`/notifications/${id}`);
};
